module.exports = __webpack_public_path__ + "img/19-1.44cfe068.png";